export default __webpack_public_path__ + "static/media/tn.08449c29.svg";